import { createContext, useContext, ReactNode } from "react";
import { useCurrentTenant } from "../auth/tenant.store";
import { TipoTenantEnum } from "../../resources/enums/tenant";

interface RegrasTenantContextData {
  useSubtenantsViews: boolean;
}

const RegrasTenantContext = createContext<RegrasTenantContextData>(
  {} as RegrasTenantContextData
);

interface RegrasTenantProviderProps {
  children: ReactNode;
}

export function RegrasTenantProvider({ children }: RegrasTenantProviderProps) {
  const { tenant } = useCurrentTenant();

  const isIncorporadoraOuAdministradora = [
    TipoTenantEnum.Incorporadora,
    TipoTenantEnum.Administradora,
  ].includes(tenant.tipoTenantId);

  return (
    <RegrasTenantContext.Provider
      value={{ useSubtenantsViews: isIncorporadoraOuAdministradora }}
    >
      {children}
    </RegrasTenantContext.Provider>
  );
}

export function useRegrasTenant(): RegrasTenantContextData {
  const context = useContext(RegrasTenantContext);

  if (!context) {
    throw new Error(
      "useRegrasTenant deve ser usado dentro de um RegrasTenantProvider"
    );
  }

  return context;
}
